const graphqlBusinessErrorPatterns = [/order_immediately_fulfilled/];

export { graphqlBusinessErrorPatterns };
